// extracted by mini-css-extract-plugin
export default {"columns":"ActivesList_columns__DL8rB","card":"ActivesList_card__naZoI","showCard":"ActivesList_showCard__gypsI","hidden":"ActivesList_hidden__a5cvp"};